'use client';

const SERVICES = [
    "SEO / SEM",
    "Social Media Marketing",
    "Website Design",
    "UI / UX Design",
    "Branding & Strategy",
    "Performance Marketing",
    "CRO",
    "Data & Analytics",
    "Google Tag Manager",
    "Local SEO",
    "SXO",
    "Consulting",
];

const ITEMS = [...SERVICES, ...SERVICES];

export default function ServiceCarousel() {
    return (
        <div className="w-full z-30 pointer-events-auto overflow-hidden">
            {/* Ambient glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-20 bg-blue-600/5 rounded-full blur-3xl pointer-events-none" />

            {/* Scrolling track */}
            <div className="relative overflow-hidden">
                {/* Edge fades */}
                <div className="absolute inset-y-0 left-0 w-16 md:w-32 z-10 pointer-events-none"
                    style={{ background: "linear-gradient(to right, #020b1e, transparent)" }} />
                <div className="absolute inset-y-0 right-0 w-16 md:w-32 z-10 pointer-events-none"
                    style={{ background: "linear-gradient(to left, #020b1e, transparent)" }} />

                <div
                    className="lw-carousel-track"
                    onMouseEnter={e => e.currentTarget.style.animationPlayState = "paused"}
                    onMouseLeave={e => e.currentTarget.style.animationPlayState = "running"}
                >
                    {ITEMS.map((service, i) => (
                        <div key={i} className="group relative flex-shrink-0 cursor-default">
                            <div
                                className="relative px-6 py-3 rounded-full border transition-all duration-300 group-hover:scale-105"
                                style={{
                                    background: "rgba(255,255,255,0.12)",
                                    borderColor: "rgba(255,255,255,0.2)",
                                    backdropFilter: "blur(4px)",
                                    WebkitBackdropFilter: "blur(4px)",
                                    boxShadow: "0 10px 30px -5px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,1)",
                                }}
                            >
                                <div
                                    className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                    style={{
                                        background: "linear-gradient(135deg, rgba(37,99,235,0.05) 0%, rgba(139,92,246,0.05) 100%)",
                                    }}
                                />
                                <span className="relative z-10 text-sm font-semibold tracking-wide whitespace-nowrap text-white">
                                    {service}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


        </div>
    );
}
